/// Checkboxes

export const HTML_Checkbox = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_83_27" fill="white">
<rect width="13" height="13" rx="4"/>
</mask>
<rect width="13" height="13" rx="4" fill="var(--primary)" stroke="var(--primary)" stroke-width="13" mask="url(#path-1-inside-1_83_27)"/>
</svg>
`

export const HTML_Checkbox_Checked = `<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_83_28" fill="white">
<rect y="0.73172" width="13.0653" height="13.0653" rx="4"/>
</mask>
<rect y="0.73172" width="13.0653" height="13.0653" rx="4" fill="#25202C" stroke="#25202C" stroke-width="13.0653" mask="url(#path-1-inside-1_83_28)"/>
<path d="M6.10451 11.2842C5.37885 10.5585 5.37885 9.38198 6.10451 8.65632L13.0437 1.71716C13.5879 1.17292 14.4703 1.17291 15.0146 1.71716V1.71716C15.5588 2.26141 15.5588 3.1438 15.0146 3.68805L7.41844 11.2842C7.05561 11.647 6.46734 11.647 6.10451 11.2842V11.2842Z" fill="#22A497"/>
<path d="M3.4678 6.65425C4.01205 6.11001 4.89445 6.11001 5.43869 6.65425L7.4343 8.64987C8.15996 9.37553 8.15997 10.5521 7.4343 11.2777V11.2777C7.07147 11.6405 6.48321 11.6405 6.12038 11.2777L3.4678 8.62514C2.92356 8.08089 2.92356 7.1985 3.4678 6.65425V6.65425Z" fill="#22A497"/>
</svg>`


/// 